import isObject from './isObject';
import RecursivePartial from '../types/RecursivePartial';

export function deepCloneWithUpdates<T>(
  original: T,
  updates: RecursivePartial<T> = {},
): T {
  const originalKeys = Object.keys(original);
  const result = {};
  originalKeys.forEach(key => {
    if (isObject(original[key])) {
      // recursion!
      result[key] = deepCloneWithUpdates(original[key], updates[key] || {});
    } else {
      result[key] = Object.prototype.hasOwnProperty.call(updates, key)
        ? updates[key]
        : original[key];
    }
  });
  return result as T;
}
